import React from 'react'
import { DynamicEntityIndex } from '@reactiveonline/reactive_admin_shared-packages'
import { dynamicTableItemRenderer } from '@reactiveonline/reactive_admin_shared-packages/utils'

const transactionTableHeadings = [
  { key: 'transaction_id',   label: 'transaction_id'   },
  { key: 'transaction_date', label: 'transaction_date' },
  { key: 'amount',           label: 'amount'           },
  { key: 'promotion_applied', label: 'promotion_applied' },
  { key: 'status',           label: 'status'           },
  { key: 'billing_cycles',   label: 'billing_cycles'   },
  { key: 'bank_message',     label: 'bank_message'     }
]

export default function Transactions({
  transactions, setTransactions, transactionsPath
}) {
  const transactionItemRenderer = (item, columns) => {
    return columns.map(column => {
      let cellValue = ''

      if (['status', 'amount'].includes(column.label)) {
        return dynamicTableItemRenderer(item, column)
      } else if (column.label === 'promotion_applied') {
        cellValue = item.promotionApplied || '-'
      } else if (column.label === 'transaction_id') {
        cellValue = item.providerTransactionId || '-'
      } else if (column.label === 'transaction_date') {
        cellValue = (
          <>
            { item.createdAtLocalTime }
            <br/>
            UTC: { item.createdAt }
          </>
        )
      } else if (column.label === 'billing_cycles') {
        cellValue = (
          <div>
            <div className="flex-box items-center m-b-10">
              Started: { item.billingStartDate }
            </div>
            <div className="flex-box items-center">
              Ending: { item.billingEndDate }
            </div>
          </div>
        )
      } else if (column.label === 'bank_message') {
        cellValue = (
          <>
            { item.responseText ? `Response: ${ item.responseText }` : '' }<br/>
            { item.responseCode ? `Code: ${ item.responseCode }` : '' }<br/>
            { item.responseType ? `Type: ${ item.responseType }` : '' }<br/>
            { item.bankAdditionalResponse ? `Reason: ${ item.bankAdditionalResponse }` : '' }<br/>
            { item.gatewayRejectionReason ? `Reason: ${ item.gatewayRejectionReason }` : '' }
          </>
        )
      }

      return (
        <div key={ column.label } className='item flex-1'>
          { cellValue }
        </div>
      )
    })
  }

  return (
    <>
      <div className="col s12">
        <div className="card">
          <div className="card-content">
            <div className="card-title">Transactions</div>
          </div>
        </div>
      </div>

      <DynamicEntityIndex
        initialItems={ transactions }
        setInitialItems={ setTransactions }
        disableDelete
        disableCustomization
        disableSearch
        entity='transactions'
        tableHeadings={ transactionTableHeadings }
        itemRenderer={ transactionItemRenderer }
        itemsPath={ transactionsPath }
        icon='fa-money-from-bracket'
        noResourcesTitle={ Support.translations.account.no_transactions }
        listColumns={ transactionTableHeadings }
        columnTranlations={ ReactiveCore.translations.columns }
        fetchOnStart
        disableUrlUpdates
      />
    </>
  )
}